import React from 'react';
import { ProgressBar } from 'react-bootstrap';

const HorizontalProgress = ({ text }) => {
  return <ProgressBar className="my-2" striped animated variant="dark" now={100} label={text} />;
};

export default HorizontalProgress;
